import {
  TextInput,
  TruFormButton,
  useToastContext,
  TruForm,
  useForm,
  PopoverChild,
  Collapse,
  required,
  nameRules,
  phoneRules,
  emailRules,
} from '@trufla-technology/trumarket-react-design-system';
import { useHistory } from 'react-router-dom';
import { useCreateUser } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { CreateUserBody } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { TeamSelect } from './select/TeamSelect';
import { LocationSelect } from './select/LocationSelect';
import './style.scss';
import { CurrencySelect } from '../components/CurrencySelect';
import { LocalizationSelect } from '../components/LocalizationSelect';
import { useState } from 'react';

export const NewUser = ({ onClose }: PopoverChild) => {
  const createUser = useCreateUser();
  const [loading, setLoading] = useState<boolean>(false);

  const history = useHistory();
  const toast = useToastContext();
  const Form = useForm<CreateUserBody>();

  const handleFinish = async (values: Partial<CreateUserBody>) => {
    setLoading(true);
    try {
      let bodyValues = {
        ...values,
        localization: {
          ...values.localization,
          datetimeFormat: 'MM/DD/YYYY hh:mm A',
        },
      };

      // @ts-ignore - backend object is optional and have undefined in some props
      const user = await createUser(bodyValues);
      if (!user?.data?.key) throw new Error('Error creating user');
      toast.success(`User created successfully`);
      history.push(`/users/${user?.data?.key}`);
      onClose();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(
        // @ts-ignore - type of response on error not exist
        err?.response?.data?.error.replaceAll('body.', '') ||
          'Something went wrong',
      );
    }
  };

  return (
    <div className="new-user-form">
      <TruForm form={Form} onFinish={handleFinish}>
        <Collapse shownItemCount={5}>
          <Form.Item
            rules={[required, ...nameRules]}
            name="fullName"
            label="Name"
          >
            <TextInput />
          </Form.Item>
          <Form.Item
            rules={[required, ...emailRules]}
            name="email"
            label="Email"
          >
            <TextInput />
          </Form.Item>
          <Form.Item rules={[required]} name="teamKeys" label="Teams">
            <TeamSelect />
          </Form.Item>
          <Form.Item rules={[required]} name="locationKeys" label="Locations">
            <LocationSelect />
          </Form.Item>
          <Form.Item
            rules={[...phoneRules]}
            name="phoneNumber"
            label="Phone Number (Opt.)"
          >
            <TextInput />
          </Form.Item>
          <Form.Item
            rules={[...nameRules]}
            name="jobTitle"
            label="Job Title (Opt.)"
          >
            <TextInput />
          </Form.Item>
          <Form.Item
            name={['localization', 'currency'] as any}
            label="Currency (Opt.)"
          >
            <CurrencySelect />
          </Form.Item>

          <Form.Item
            name={['localization', 'locale'] as any}
            label="Default Language (Opt.)"
          >
            <LocalizationSelect />
          </Form.Item>
        </Collapse>
        <Form.Item shouldUpdate>
          {() => (
            <>
              <TruFormButton
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={!Form.valid()}
              >
                Add
              </TruFormButton>
              <TruFormButton htmlType="reset" onClick={onClose}>
                Cancel
              </TruFormButton>
            </>
          )}
        </Form.Item>
      </TruForm>
    </div>
  );
};
